import type { Hit as AlgoliaHit } from 'instantsearch.js';
import type { SendEventForHits } from 'instantsearch.js/es/lib/utils';
import { useConfigContext } from '../../ConfigProvider.tsx';
import type {AlgoliaProductAttributes} from "../../AlgoliaProductAttributes";
import { Highlight } from 'react-instantsearch';

export default function ItemlistElement({
                                            hit,
                                            sendEvent,
                                        }: {
    hit: AlgoliaHit<AlgoliaProductAttributes>;
    sendEvent: SendEventForHits;
}) {
    const {
        tc,
        algoliaConfig: { customizedUrl, shippingLink },
    } = useConfigContext();

    const itemLink = '/' + customizedUrl + hit.itemLink;
    const addToFavoriteEvent = () =>
        sendEvent('conversion', hit, 'PLP: Product Added To Favorites');

    if (!itemLink || !tc) return null;

    return (
        <li
            key={hit.objectID}
            id={'item_' + hit.itemId}
            className="algoliaSearchItemlistElement js-updateAlgoliaItemboxElement"
            role="listitem"
            data-itemno={hit.itemNo}
            data-item-id={hit.itemId}
        >
            <div className="itemlistElement">
                <div className="itemlistElement__wrapper">
                    <div className="itemlistElement__badges algoliaPromotionsWrapper"></div>

                    <a href={itemLink} title={hit.description} data-gtm-item={hit.itemId}
                       className="itemlistElement__media gtm-product-click">

                        <span className="itemlistElement__image image">
                            <img className="itembox__imageSrc"
                                 src={hit?.itemImage}
                                 alt={hit.description}
                                 width="300" height="300" loading="lazy"/>
                        </span>
                    </a>

                    <div className="itemlistElement__description">
                        <a className={"itemlistElement__name gtm-product-click"} href={itemLink}
                           title={hit.description} data-gtm-item={hit.itemId}>
                            <span className="itemlistElement__brand"></span>
                            <Highlight hit={hit} attribute="description"/>
                        </a>
                    </div>

                    <div className="itemlistElement__info">
                        <div className="itemlistElement__item_no">
                            {hit.itemNo}
                        </div>
                        <div className="itemlistElement__inventory algoliaInventorySign"><span className="loadSkeleton">XXX,XX</span></div>
                    </div>

                    <div className="itemlistElement__prices">
                        <div className="algoliaPrices">
                            <span className="loadSkeleton">XXX,XX €</span>
                        </div>
                        <div className="priceNotice">
                            <span>{tc['vatAndShipText']}, </span>
                            {shippingLink && (
                                <a href={shippingLink} title={tc['shippingDetails']}>
                                    {tc['plusShipping']}
                                </a>
                            )}
                        </div>
                    </div>

                    <div className="itemlistElement__addon">
                        <div className="itemlistElement__actions">
                            <div
                                className="algoliaFavoriteWrapper"
                                suppressHydrationWarning
                            >
                                  <span className="actionIcon">
                                    <i className="icon icon-favorites" aria-hidden={true}></i>
                                  </span>
                            </div>
                        </div>
                        <div className="itemlistElement__orderButtonContainer">
                            {hit.isSet || hit.hasVariants || hit.isRequested || hit.isCustomizable ? (
                                <a className="gtm-product-click button button--primary button--variant minimalOrderButton" href={itemLink}
                                   title={hit.description} data-gtm-item={hit.itemId}>
                                    <i className="icon icon-arrow-right"></i>
                                </a>
                            ): (
                                <div>
                                   <form
                                       name={'form_' + hit.itemNo}
                                        id={'form_' + hit.itemNo}
                                        method="POST"
                                        data-action="shop_add_all_items_to_basket"
                                        className="algoliaOrderbuttonWrapper"
                                    >
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
}